import { toast } from "react-toastify";
import { decryptResponse } from "../Utility";
import { auth, logout } from "../Components/firebase/firebase";
import axios from "./Axios"; // import your default instance

const getAccessToken = async () => {
  try {
    return await auth?.currentUser?.getIdToken();
  } catch (err) {
    console.warn("Failed to get token:", err);
    return null;
  }
};

export const setupAxiosInterceptors = () => {
  axios.interceptors.request.use(async (config) => {
    const newToken = await getAccessToken();

    if (newToken) {
      config.headers.Authorization = `Bearer ${newToken}`;
    }

    // FIX: Normalize double slashes in URL (preserve https://)
    if (config.url) {
      config.url = config.url.replace(/([^:]\/)\/+/g, "$1");
    }

    return config;
  });

  axios.interceptors.response.use(
    (response) => {
      if (
        response.status === 200 &&
        response.headers["content-type"] === "text/plain"
      ) {
        response.data = decryptResponse(response.data);
      }
      return response;
    },
    (error) => {
      const status = error?.response?.status;

      if (status === 401) {
        logout(auth);
      } else if (status && status !== 422 && !error.config?.skipInterceptorToast) {
        toast.info(
          "Request failed. Please check your internet connection and retry!"
        );
      }

      return Promise.reject(error);
    }
  );
};
